<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 14.25 14.25" :class="[`${prefix}-icon`, `${prefix}-icon-history2`]" width="1em" height="1em" v-bind="$attrs"><path d="M0,7.125C0,3.18996,3.18996,8.97914e-8,7.125,8.97914e-8C11.06,8.97914e-8,14.25,3.18996,14.25,7.125C14.25,11.06,11.06,14.25,7.125,14.25C3.18996,14.25,0,11.06,0,7.125ZM13.0286,7.125C13.0286,3.8646,10.3854,1.22143,7.125,1.22143C3.8646,1.22143,1.22143,3.8646,1.22143,7.125C1.22143,10.3854,3.8646,13.0286,7.125,13.0286C10.3854,13.0286,13.0286,10.3854,13.0286,7.125ZM9.86885,7.6695C9.85226,7.34502,9.58452,7.09034,9.25962,7.08997L7.56713,7.08997L7.56713,5.39748L7.56387,5.33519C7.53037,5.01202,7.2497,4.77166,6.92523,4.78825C6.60075,4.80485,6.34607,5.07258,6.3457,5.39748L6.3457,7.70069L6.34855,7.76339C6.3807,8.07489,6.64326,8.31159,6.95642,8.3114L9.25962,8.3114L9.32192,8.30814C9.64508,8.27464,9.88544,7.99397,9.86885,7.6695Z" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconHistory2',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
